module.exports = function anonymous(locals, filters, escape, rethrow) {
    escape = escape || function(html) {
        return String(html).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&#39;").replace(/"/g, "&quot;");
    };
    var __stack = {
        lineno: 1,
        input: '<div class="icon">\n  <image height="25px" width="25px" src="<%= display.iconUrl %>" alt="<%= display.name %>"/>\n</div>\n\n<div class="path">\n  <div class="context">\n      <p class="context-name"><%= display.organization %></p>\n  </div>\n  <div class="context">\n    <%- icons.chevron %>\n    <p class="context-name"><%= display.costcenter %></p>\n  </div>\n  <div class="context">\n    <%- icons.chevron %>\n    <p class="context-name"><%= display.name %></p>\n  </div>\n</div>\n',
        filename: "."
    };
    function rethrow(err, str, filename, lineno) {
        var lines = str.split("\n"), start = Math.max(lineno - 3, 0), end = Math.min(lines.length, lineno + 3);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    }
    try {
        var buf = [];
        with (locals || {}) {
            (function() {
                buf.push('<div class="icon">\n  <image height="25px" width="25px" src="', escape((__stack.lineno = 2, display.iconUrl)), '" alt="', escape((__stack.lineno = 2, display.name)), '"/>\n</div>\n\n<div class="path">\n  <div class="context">\n      <p class="context-name">', escape((__stack.lineno = 7, display.organization)), '</p>\n  </div>\n  <div class="context">\n    ', (__stack.lineno = 10, icons.chevron), '\n    <p class="context-name">', escape((__stack.lineno = 11, display.costcenter)), '</p>\n  </div>\n  <div class="context">\n    ', (__stack.lineno = 14, icons.chevron), '\n    <p class="context-name">', escape((__stack.lineno = 15, display.name)), "</p>\n  </div>\n</div>\n");
            })();
        }
        return buf.join("");
    } catch (err) {
        rethrow(err, __stack.input, __stack.filename, __stack.lineno);
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/cam-context-switcher/templates/cam-context-switcher.ejs
// module id = 84
// module chunks = 0